@if (cartPreviewQuantityInputBareHasButtons) {
  <div class="input-group quantity">
    <button class="input-group-text py-0 px-2" (click)="quantityDecrease()">-</button>
    <input class="form-control p-0 quantityInput" type="number" [step]="min" [min]="min" [max]="max" [(ngModel)]="quantity" (change)="quantityChanged()" />
    <button class="input-group-text py-0 px-2" (click)="quantityIncrease()">+</button>
  </div>
}

@if (!cartPreviewQuantityInputBareHasButtons) {
  <input class="form-control p-0 quantityInput" type="number" [step]="min" [min]="min" [max]="max" [(ngModel)]="quantity" (change)="quantityChanged()" />
}
